import config from 'config';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useAppDispatch } from 'reducer';
import { hideDrawer } from 'reducer/slices/drawerSlice';
import gather from 'tools/gather';
import utils from 'tools/utils';

let timer: any = null;
let end = moment()
  .add(5, 'minutes')
  .unix();
// let end = moment().add(10, 'seconds').unix();

const Checker = ({ check, uId }: any) => {
  const dispatch = useAppDispatch();
  const [result, setResult] = useState<any>();

  const init = async () => {
    if (end < moment().unix()) {
      setResult({
        error: 20000,
      });
      return;
    }

    const res = await gather(`${config.apiUrl}/checker/${check}`).get();
    if (res.code === 200 && res.data.amount) {
      setResult(res.data);
    } else {
      timer = setTimeout(() => {
        init();
      }, 5000);
    }
  };

  useEffect(() => {
    init();

    return () => {
      window.history.pushState(null, '', window.location.pathname);
      clearTimeout(timer);
      timer = null;
    };
  }, []);

  return (
    <div className='popup_page contain_center'>
      <div className='back_to_main' onClick={() => dispatch(hideDrawer())}>
        <div className='back_icon'></div>
      </div>
      <h3>شماره درخواست: {uId}</h3>
      <div className='form'>
        {result ? (
          result.error ? (
            <div className='wrong_info'>{config.errorCode['code_' + result.error] || config.errorCode['errorFound']}</div>
          ) : (
            <div className='order_show'>
              <span>
                مقدار: {utils.formatter(result.amount)} {result.coin}
              </span>
              <span>تبدیل شده: {utils.formatter(result.converted)} HotVoucher</span>
              {result.voucher && <span>ووچر: {result.voucher}</span>}
              {result.voucher1 && <span>ووچر: {result.voucher1}</span>}
              <span>سمت: {result.side}</span>
              <span>نوع: {result.type}</span>
              <span>وضعیت: {result.status}</span>
              <span>تاریخ: {moment(result.createdAt).format('YYYY-MM-DD , HH:mm:ss')}</span>
            </div>
          )
        ) : (
          <>
            لطفاً صبر کنید...
            <br />
            تا پایان بررسی از بستن صفحه خود داری نمایید
          </>
        )}
      </div>
    </div>
  );
};

export default Checker;
